export default __webpack_public_path__ + "static/media/rogers-logo.a7a9c772.svg";